import { jsx as l } from "react/jsx-runtime";
const e = (a) => /* @__PURE__ */ l(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    ...a,
    children: /* @__PURE__ */ l(
      "path",
      {
        fill: "currentcolor",
        d: "M16.828 3a3 3 0 0 1 1.977.743l.145.136 1.17 1.17a3 3 0 0 1 .137 4.1l-.136.144L18.415 11l2.292 2.293a1 1 0 0 1 .083 1.32l-.083.094-4 4a1 1 0 0 1-1.497-1.32l.083-.094L18.585 14l-1.586-1.585-7.464 7.464a3.83 3.83 0 0 1-2.474 1.114l-.233.008c-.674 0-1.33-.178-1.905-.508l-1.216 1.214a1 1 0 0 1-1.497-1.32l.083-.094 1.214-1.216a3.83 3.83 0 0 1 .454-4.442l.16-.17L14.707 3.879a3 3 0 0 1 1.923-.873zm0 2a1 1 0 0 0-.608.206l-.1.087L14.415 7 17 9.585l1.707-1.706a1 1 0 0 0 .284-.576l.01-.131a1 1 0 0 0-.207-.609l-.087-.099-1.171-1.171A1 1 0 0 0 16.828 5"
      }
    )
  }
);
export {
  e as default
};
